import { render, staticRenderFns } from "./GeneratorYears.vue?vue&type=template&id=1fad5258&"
import script from "./GeneratorYears.vue?vue&type=script&lang=js&"
export * from "./GeneratorYears.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports